import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { LayoutProps } from '../interface/MyInterfaces';

import { logout } from '../actions/UserActions';
import { isAgg } from './Common/Helpers';

class BlankLayout extends React.Component<LayoutProps, {}> {

    public render() {

        const iris_logo = require('../images/IRISLogo_Large.png');

        const authenticated = this.props.UserState.isAuthenticated == 1 ? true : false

        let logoUni;
        try {
            logoUni = require(`../images/univ_logos/${this.props.UserState.report_display_id}.png`);
        }
        catch (err) {

        }

        return (
            <div className='container-fluid' >
                <div className="page-content-container">
                    <div className='row header-banner'>
                        <div className='col-md-10 col-sm-6 header-banner-textbox-right'>
                            <p className="header-banner-text">Institute for Research on Innovation and Science (IRIS)</p>
                        </div>
                        <div className='col-md-2 col-sm-6'>
                            {
                                // TODO: add help page outside dashboard for guest users
                                //authenticated &&
                                //<div className="header-banner-textbox-left">
                                //    <Link to="/dashboard"><p className="header-banner-text">Dashboard</p></Link>
                                //    <p className="header-banner-text">|</p>
                                //    <Link to="/help"><p className="header-banner-text">Help</p></Link>
                                //</div>
                            }
                        </div>
                    </div>
                    <div className='row brand-header'>
                        <div className='col-md-4 col-sm-6 brand-header-logo-container'>
                            <img className="img-fluid brand-header-logo" src={String(iris_logo)} alt='IRIS Logo' />
                        </div>
                        <div className='col-md-8 col-sm-6'>
                            {authenticated &&
                                <div className="user-profile-info-container">

                                    {
                                        !isAgg(this.props.UserState.report_display_id) && <div className="user-university-logo-container">
                                            <img className="img-fluid user-university-logo" src={String(logoUni)} alt='Logo' />
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <div className="row divider-IRIS-light-blue"></div>
                    <div className='row'>
                        <div className='col-md-12 page-content'>
                            {this.props.children}
                        </div>
                    </div>

                </div >
                <div className='row footer-container'>
                    <div className='col-md-12 footer-info'>
                        © {new Date().getFullYear()} Institute for Research on Innovation and Science (IRIS). All rights reserved.
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    UserState: state.userProperties
});

export default connect(mapStateToProps)(BlankLayout);